import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import {initReactI18next} from 'react-i18next';

i18n
    .use(initReactI18next)
    .use(Backend)
    .init({
        backend: {
            // for all available options read the backend's repository readme file
            loadPath: (import.meta.env.PROD ? import.meta.env.VITE_REACT_APP_JUNCTION : '') + '/locales/{{lng}}/{{ns}}.json'
        },

        fallbackLng: 'fr',

        // have a common namespace used around the full app
        ns: ['fees-simulator'],
        defaultNS: 'fees-simulator',

        debug: false,

        interpolation: {
            escapeValue: false,
            formatSeparator: ',',
            format: (value, formatting) => {
                if (formatting === 'highlight') {
                    return `<span class="highlight">${value}</span>`;
                } else {
                    return value;
                }
            }
        },

        react: {
            wait: true
        }
    });

export default i18n;
